import React from 'react';
import classnames from 'classnames';
import './index.scss';

export default function SpeedBtn({ text = '加速', handleSpeed, disabled, ...other}) {
  return (
    <div className="start-box">
      <button 
        className={classnames("start-btn", { handleSpeed, disabled, ...other })} 
        onClick={handleSpeed} 
        disabled={disabled}
      >
        { text }
      </button>
    </div>
  )
}